export default () => {
  const domNodes = dom.querySelectorAll(".render-app-search-widget");

  let disposableWidgets: DisposableApp[] = [];
  let disposing = false;
  if (domNodes.length > 0) {
    import("./index" /* webpackChunkName: "search-widgets" */).then(
      ({ default: startApp }) => {
        if (!disposing) {
          const createWidgets = () =>
            domNodes.forEach(domNode => {
              disposableWidgets.push(startApp(domNode as HTMLElement));
            });

          if ("SearchWidget" in window) {
            createWidgets();
          } else {
            const script = document.createElement("script");

            script.type = "text/javascript";
            script.src =
              "https://dynamic-faq.widget.canal-overseas.com/ns/widget/prod/v2.12.1/searchWidget.js";
            script.onload = () => {
              if (!disposing) {
                createWidgets();
              }
            };

            // eslint-disable-next-line no-document-queryselector
            document.querySelector("head")!.appendChild(script);
          }
        }
      }
    );
  }

  return function disposeCallback() {
    disposing = true;

    disposableWidgets.forEach(disposeWidget => {
      if (disposeWidget !== null) {
        disposeWidget();
      }
    });
  };
};
